import { toFlatField } from '../oasis-types';
export const SuppliesVersioned = {
    problems: { e1: { alias: 'problems', timepoint: ['*'] } },
};
export const Supplies = toFlatField(SuppliesVersioned);
